import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { Server } from '../models/server.model';

const COLLECTION_NAME = 'servers';

@Injectable({
  providedIn: 'root'
})
export class ServiceService {

  private collection: AngularFirestoreCollection<Server> = this.afs.collection(COLLECTION_NAME);

  constructor(private afs: AngularFirestore) { }

  add(server: Server) {
    server.id = this.afs.createId();
    return this.collection.doc(server.id).set(server);
  }

  update(server: Server) {
    return this.collection.doc(server.id).set(server);
  }

  getByOwnerId(id: string): Observable<Server[]> {
    return this.afs.collection<any>('servers', ref => ref.where('owner', '==', id)).valueChanges();
  }

  delete(server: Server) {
    return this.collection.doc(server.id).delete();
  }

  search(parameter: string): Observable<Server[]> {
    const filterByName = this.afs.collection<Server>(COLLECTION_NAME,
      ref => ref.orderBy('name').startAt(parameter).endAt(parameter + '\uf8ff'))
      .valueChanges();

    const filterByEnvironment = this.afs.collection<Server>(COLLECTION_NAME,
      ref => ref.orderBy('enviroment').startAt(parameter).endAt(parameter + '\uf8ff'))
      .valueChanges();

    return combineLatest<any[]>(filterByName, filterByEnvironment).pipe(map(arr => arr.reduce((acc, cur) => acc.concat(cur))));
  }

}
